<template>
    <v-app id="app">
      <v-main>
        <router-view/>
        <notifications classes="main-notification" position="bottom right" group="main"/>
        <notifications classes="main-notification" position="bottom center" group="center"/>
        </v-main>
    </v-app>
</template>

<script>

import constants from "@/config/constants";

export default {
    name: 'App',
    mounted() {
        this.loadAndRegisterPaddle()
    },
    methods: {
        loadAndRegisterPaddle() {
            const el = document.createElement('script')
            el.onload = () => {
                // eslint-disable-next-line no-undef
                Paddle.Setup({
                    vendor: constants.PADDLE_VENDOR_ID,
                    eventCallback: (data) => this.$gtag.event(constants.ANALYTICS_EVENTS.CHECK_OUT, {
                        event_category: constants.ANALYTICS_EVENTS.PAYMENT_CATEGORY,
                        event_label: data.event
                    })
                });
            }
            el.setAttribute('src', 'https://cdn.paddle.com/paddle/paddle.js')
            document.body.appendChild(el)
        },
    }
}
</script>

<style>

</style>
